import { customElement } from 'lit/decorators.js';
import { html } from 'lit';
import WwpOverview from '@kisters/wiski-web/components/wwp-overview/wwp-overview';
import { template, formatNumber} from '@kisters/wiski-web/common';

@customElement('wwp-hdoe-overview')
export default class HdoeOverview extends WwpOverview {

get formatters() {
  return {
    ...super.formatters, // inherit all parent formatters
    number(
      val,
      opt: {
        options: any;
        locale: string | undefined;
      } = { options: undefined, locale: undefined },
      col,
      item,
    ) {
      const formatted = formatNumber(parseFloat(val), opt.options || {});
      return html`
        <div style="${col.css || ''}" class="cell number">
          ${col.prefix ? template(col.prefix, item) : ''}
          ${val === undefined ||
          val === null ||
          val === '' ||
          Number.isNaN(val)
            ? ''
            : formatted}
          ${val && col.suffix ? template(col.suffix, item) : (col.suffix ? template(col.suffix, item) : '')}
        </div>
      `;
    },
  };
}

}